import * as React from 'react'
import { useDebounce } from './useDebounce'

type Dimension = { width: number; height: number }

export function useDramaticallyInefficientContain(
  containerRef: React.RefObject<HTMLDivElement>,
  ratio: number,
  deps: any[],
): Dimension {
  const [dimension, setDimension] = React.useState({
    width: 0,
    height: 0,
  })

  const setVideoDimensionDebounce = useDebounce(setVideoDimension, false, 200)

  React.useEffect(() => {
    setVideoDimension()
    window.addEventListener('resize', setVideoDimensionDebounce)
    return () => {
      window.removeEventListener('resize', setVideoDimensionDebounce)
    }
  }, deps)

  return dimension

  function setVideoDimension() {
    if (containerRef.current !== null) {
      setDimension(computeContainDimension(containerRef.current, ratio))
    }
  }
}

function computeContainDimension(container: HTMLElement, videoRatio: number): Dimension {
  const style = getComputedStyle(container)
  const containerInnerWidth = container.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
  const containerInnerHeight = container.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom)

  const containerRatio = containerInnerWidth / containerInnerHeight

  if (containerRatio < videoRatio) {
    return {
      width: containerInnerWidth,
      height: containerInnerWidth / videoRatio,
    }
  } else {
    return {
      height: containerInnerHeight,
      width: videoRatio * containerInnerHeight,
    }
  }
}
